

















































































































import { General } from "@/utils/constants";
export default {
  name: "TramitingTooltip",
  filters: {
    leadingZero: (value: number) => {
      return value !== 0 ? String(value).padStart(2, "0") : "0";
    }
  },
  props: {
    isDispatch: {
      type: Boolean,
      default: false
    },
    hasMandatoryFilled: {
      type: Boolean,
      default: false
    },
    hasPrimaryFile: {
      type: Boolean,
      default: false
    },
    isInitialFileSigned: {
      type: Boolean,
      default: false
    },
    hasSignatures: {
      type: Boolean,
      default: false
    },
    pendingSignatures: {
      type: Number,
      default: 0
    },
    declinedSignatures: {
      type: Number,
      default: 0
    },
    hasDOE: {
      type: Boolean,
      default: false
    },
    hasDOEProgrammedSignatures: {
      type: Boolean,
      default: false
    },
    isAutomaticTramiting: {
      type: Boolean,
      default: false
    },
    hasPermissionProtocoller: {
      type: Boolean,
      default: false
    },
    position: {
      type: String,
      default: "is-right"
    }
  },
  data() {
    return { General };
  }
};
